import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TabsModule } from 'ngx-bootstrap';

import { PraticheDetailComponent } from '../pratiche-detail/pratiche-detail.component';
import { PratichePaymentComponent } from '../pratiche-payment/pratiche-payment.component';
import { PraticheInstalmentComponent } from '../pratiche-instalment/pratiche-instalment.component';
import { PraticheDocumentComponent } from '../pratiche-document/pratiche-document.component';
import { DataService } from '../../../services/data.service';

@Component({
	selector: 'app-pratiche-tabs',
	templateUrl: './pratiche-tabs.component.html',
	styleUrls: ['./pratiche-tabs.component.css']
})
export class PraticheTabsComponent implements OnInit {
	@Input() public row: any;
	@Input() writePermission: boolean = false;
	@Output() newRate = new EventEmitter();

	modalInput: any = {
		size: '',
		title: '',
		subtitle: '',
		data: {
			id: 0,
			crc: 0,
			person: null,
			uid: null,
			id_prat: null,
			reset: false,
		}
	};

	constructor(private dataService: DataService) {
	}

	ngOnInit() {
		console.log('PRATICHE TABS|ROW', this.row);
	}

	modificaPratica() {
		console.log("CLICK|PRATICHE-TABS|MODIFICAPRATICA");
		this.modalInput = {
			size: 'large-modal',
			title: 'Modifica',
			subtitle: 'Pratica: ' + this.row.id_prat,
			data: {
				id: this.row.id,
				crc: Math.floor(Math.random() * 100),
				person: null,
				uid: Number(this.row.id),
				id_prat: this.row.id_prat,
				new_prat: false,
				initial_state: this.row.stato_id == 1,
				reset: true,
			}
		};
		this.modalInput.data = JSON.stringify(this.modalInput.data);
		//this.loadFromDB(false);
		console.log("PRATICHE-TABS| MODIFICAPRATICA", this.modalInput, this.row);
	}

	openNewRate(event) {
		this.newRate.emit(event);
	}
}
